import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class GoogleTagManagerService {
    private readonly isBrowser: boolean;

    constructor(@Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    isAvailable(): boolean{
        if (this.isBrowser &&
            (<any>window).dataLayer) {
            return true;
        } else {
            return false;
        }
    }

    // Function to push new data to dataLayer array
    pushTag(tag: object) {
        if (this.isBrowser &&
            (<any>window).dataLayer) {
            (<any>window).dataLayer.push(tag);
        }
    }

}
